import { render, staticRenderFns } from "./common-company-history.vue?vue&type=template&id=64fd9e8a&scoped=true"
import script from "./common-company-history.vue?vue&type=script&lang=js"
export * from "./common-company-history.vue?vue&type=script&lang=js"
import style0 from "./common-company-history.vue?vue&type=style&index=0&id=64fd9e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd9e8a",
  null
  
)

export default component.exports